import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap'
import CreateTest from '../components/tests/CreateTest'
import TestsContainer from '../containers/TestsContainer'
import BudgetContainer from '../containers/BudgetContainer'
import Load from '../components/Load'
import {clearDataError, showAlert, retrieveBudget, retrieveGroups} from '../actions/index'
import {noiseBudgetBreached} from '../components/budget/BudgetView'
import _ from 'lodash'

_.mixin({
    mapIds: (obj, arr) => {
        arr.forEach(a => obj[a.id] = a)
        return obj
    },
    unmapIds: (obj, arr) => {
        arr.forEach(a => obj[a.id] = undefined)
        return obj
    }
})

class DashboardContainer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            creatingTest: false,
            editingTest: undefined
        }
    }

    componentWillUpdate(nextProps) {
        if (!this.props.user && nextProps.user) {
            this.refreshBudget()
        }
    }

    refreshBudget = () => {
        this.props.dispatch(retrieveBudget())
    }

    closeTestEditor = () => {
        this.setState({
            creatingTest: false,
            editingTest: undefined
        })
    }

    retrieveAllGroups = () => {
        this.props.dispatch(retrieveGroups())
    }

    testContent = () => {

        //console.log('testcontent', this.props.unplannedTestsStatus)

        if (this.state.creatingTest && !this.props.user.group) {
            return <div className='create-form-container'>
                User without a group cannot create tests
            </div>
        } else if (this.state.creatingTest || this.state.editingTest) {
            //console.log('edit test',
            //    this.state.editingTest,
            //    this.props.groups,
            //    ((this.state.editingTest || {}).test || {}).group || '_',
            //    this.props.groups[((this.state.editingTest || {}).test || {}).group || '_']
            //)

            return <CreateTest
                editingTest={this.state.editingTest}
                dispatch={this.props.dispatch}
                user={this.props.user}
                group={this.props.group}
                testGroup={this.props.groups[((this.state.editingTest || {}).test || {}).group || '_']}
                close={this.closeTestEditor}
                uploadUrl={this.props.uploadUrl}
                dataError={this.props.dataError || {}}
                loading={this.props.loading}
                unplannedTestsStatus={this.props.unplannedTestsStatus}
            />
        } else {

            //console.log('budget br', noiseBudgetBreached(this.props.budget))

            return <TestsContainer
                user={this.props.user}
                group={this.props.group}
                loading={this.props.loading}
                dispatch={this.props.dispatch}
                underBudgetTests={(this.props.budget || {}).underBudgetTests || []}
                overBudget={noiseBudgetBreached(this.props.budget)}
                groups={this.props.groups}
                retrieveAllGroups={this.retrieveAllGroups}
                editTest={(test, completing) => this.setState({
                        editingTest: {
                            test: test,
                            completing: completing
                        }
                    })
                }
                refreshBudget={this.refreshBudget}
            />
        }
    }

    createTestClicked = () => {
        if (!this.props.group) {
            this.props.dispatch(showAlert('warning', 'No maintenance agency available'))
            return
        }

        this.props.dispatch(clearDataError('createTest'))
        this.props.dispatch(clearDataError('updateTest'))
        this.setState({
            creatingTest: !this.state.creatingTest,
            editingTest: undefined
        })
    }

    render() {

        //console.log('dashboard error', this.props.dataError)

        let content = <Load />
        if (this.props.user) {
            content = <Grid fluid>
                <Row>
                    <Col xs={12} md={8} style={{marginBottom: '20px'}}>
                        {this.testContent()}
                    </Col>

                    <Col xs={12} md={4} className="col-padding-left">
                        <BudgetContainer
                            user={this.props.user}
                            //group={this.props.group}
                            creatingOrEditingTest={this.state.creatingTest || this.state.editingTest}
                            scheduleNewTest={this.createTestClicked}
                            budget={this.props.budget}
                            loading={this.props.loading}
                        />
                    </Col>
                </Row>
            </Grid>
        }

        return (
            <div>
                <div id="print-mount"/>
                <div id="react-no-print">
                    <h2 className="header-h2">CHRISTCHURCH AIRPORT</h2>
                    <h3 className="header-h3">Engine Testing Management System</h3>
                    {content}
                </div>
            </div>
        );
    }
}

// const validate = values => {
//     //console.log("validate values", values);
//     const errors = {}
//     if (!values.firstName) {
//         errors.firstName = 'Required'
//     } else if (!values.lastName) {
//         errors.lastName = 'Required'
//     } else if (!values.profileImage) {
//         errors.profileImage = 'Required'
//     }
//
//
//     return errors
// }

// DashboardContainer = reduxForm({
//     form: 'dashboard',
//     validate
// })(DashboardContainer)

export default DashboardContainer = connect(state => {

    //console.log('connectDC', state)

    return {
        user: (state.data || {}).ETMSUser,
        group: (state.data || {}).ETMSUserGroup,
        groups: _.mapIds({}, (state.data || {}).groups || []),
        initialValues: (state.data || {}).user,
        loading: (state.data || {}).loading,
        dataError: (state.data || {}).dataError,
        uploadUrl: (state.data || {}).uploadUrl,
        unplannedTestsStatus: (state.data || {}).unplannedTestsStatus,
        budget: (state.data || {}).budget
    }
})(DashboardContainer);


 





// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.jsx